module.exports = __webpack_public_path__ + "static/media/close.135e8157.svg";